"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconCompare = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Compare" }, props),
        react_1.default.createElement("title", null, "Compare"),
        react_1.default.createElement("path", { d: "M11.529 78.59L8.57 62.72l99.825-17.764 2.958 15.879-99.825 17.753z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M60.064 69.975l-28.639 41.443h57.15l-28.51-41.443z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M28.575 58.821c11.048 0 20.004-8.75 20.004-19.542 0-10.794-8.956-19.543-20.004-19.543-11.048 0-20.004 8.75-20.004 19.543S17.527 58.82 28.575 58.82z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M91.425 47.657c11.048 0 20.004-8.75 20.004-19.543S102.473 8.571 91.425 8.571c-11.048 0-20.004 8.75-20.004 19.543s8.956 19.543 20.004 19.543z", fill: "#D44513" })));
};
exports.default = BrandIconCompare;
